import React from "react";
import "./input.scss";

const Input = ({ icon, className, file, action, ...props }) => {
  return (
    <div className='input'>
      <input className={`input__field ${className}`} {...props} />
      {icon && (
        <div className='input__icon'>
          <i className={icon}></i>
        </div>
      )}
      {file && (
        <div className='input__files' onClick={action}>
          <span className='icon icon--bin mr-2'></span>
          <span>Anhang</span>
        </div>
      )}
    </div>
  );
};

export default Input;
